import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest, CallEffect, PutEffect } from 'redux-saga/effects';
import {
  actions,
  REQUEST_GET_WORKSPACES,
  REQUEST_SET_CURRENT_WORKSPACE,
} from 'src/redux/reducers/workspace';
import api from 'src/services/authApi';
import { ApiResponse } from 'src/services/authApi/types';

function* getWorkspaces(): Generator<CallEffect | PutEffect, void, ApiResponse<Workspace[]>> {
  try {
    const response = yield call(api.get, `/workspace?order[name]=ASC`);

    if (response?.data) {
      yield put(actions.receiveGetWorkspaces(response.data));
    }
  } catch (error) {
    yield put(actions.failedGetWorkspaces(new Error('Could not get workspaces')));
  }
}

function* setCurrentWorkspace(
  action: PayloadAction<{ workspaceId: string }>
): Generator<CallEffect | PutEffect, void, ApiResponse<Workspace[]>> {
  try {
    const response = yield call(api.patch, `/user/currentWorkspace`, {
      workspaceId: action.payload.workspaceId,
    });

    if (response?.data) {
      yield put(actions.receiveSetCurrentWorkspace());
    }
  } catch (error) {
    yield put(actions.failedSetCurrentWorkspace(new Error('Could not set current workspaces')));
  }
}

export default function* root() {
  yield takeLatest(REQUEST_GET_WORKSPACES, getWorkspaces);
  yield takeLatest(REQUEST_SET_CURRENT_WORKSPACE, setCurrentWorkspace);
}
